import axios from "axios";
import { appConstants } from "./appConstants";
import { loadingAction } from "ReduxReducers/loadingReducer";
import { IdleAction } from "ReduxReducers/tokenGenerateTime";
import { generateToken } from "./generic";

let axiosConfig = {
  headers: {
    Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}`,
  },
}
let id;
if (JSON.parse(sessionStorage.getItem('LOGIN_DETAILS')) !== null) {
  id = JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'))._id
}

export const getDataOnScreen = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "quotation/fetchDetailsOnAddQuotationScreen", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("error getDataOnScreen===>", error?.response?.data?.Result_Message)
    })
}
export const getEmailAndTemplateForQuotation = async (values, callBack, dispatch) => {

  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "quotation/fetchCustomerEmailWithTemplate", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("error getEmailAndTemplateForQuotation===>", error?.response?.data?.Result_Message)
    })
}



export const getContactsForQuotation = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "quotation/fetchContactsForQuotation", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      // dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      // dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("error getDataOnScreen===>", error?.response?.data?.Result_Message)
    })
}
export const getItemsForQuotation = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "quotation/fetchItemsForQuotation", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("error getDataOnScreen===>", error?.response?.data?.Result_Message)
    })
}
export const PreviewQuotationDetails = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "quotation/previewQuotationDetails", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()))
    }).catch(async error => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch)
      console.log("error PreviewQuotationDetails===>", error?.response?.data?.Result_Message)
    })
}
export const getQuotationDetailsByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "quotation/fetchQuotationDetailsByID", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("error getDataOnScreen===>", error?.response?.data?.Result_Message)
    })
}
export const SaveQuotation = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "quotation/addQuotation", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("Error while Saving: ", error?.response?.data?.Result_Message)
    })
}

export const UpdateQuotation = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "quotation/updateQuotation", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)

      console.log("Error while Updatation: ", error?.response?.data?.Result_Message);
    })
}

export const getQuotationExpiryValues = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "quotation/fetchQuotationExpiryValues", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("error getDataOnScreen===>", error?.response?.data?.Result_Message)
    })
}


export const downloadQuotation = async (values, callback, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "quotation/downloadQuotation", values, axiosConfig)
    .then((res) => {
      callback(res)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("error downloadQuotation===>", error?.response?.data?.Result_Message)
    })
}

export const viewQuotationDetails = async (values, callback, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "quotation/viewQuotationByID", values, axiosConfig)
    .then((res) => {
      callback(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("error viewQuotationDetails===>", error?.response?.data?.Result_Message)
    })
}